import * as bootstrap from 'bootstrap'
import { 
  validateCreditCardFields, 
  isCreditCardPaymentSelected, 
  areTermsAccepted 
} from './services/form-utils'

/**
 * Checkout Form Initialization
 * 
 * Handles checkout form setup on page load:
 * - Terms acceptance button state
 * - Form validation on submit
 * 
 * Note: Cost calculations and shipping option changes are handled by
 * the shipping-costs Stimulus controller for proper SRP.
 */

document.addEventListener('turbo:load', initializeCheckoutForm)

function initializeCheckoutForm() {
  const checkoutForm = document.getElementById('checkout_form')
  if (!checkoutForm) return
  
  initializeTermsButton()
  setupFormValidation(checkoutForm)
}

/**
 * Initializes the terms acceptance button state
 */
function initializeTermsButton() {
  const termsCheckbox = document.getElementById('customer_accepted_order_terms')
  if (termsCheckbox) {
    updateCheckoutButtonState(termsCheckbox.checked)
    
    termsCheckbox.addEventListener('change', (event) => {
      updateCheckoutButtonState(event.target.checked)
    })
  }
}

/**
 * Updates the checkout submit button based on terms acceptance
 * @param {boolean} termsAccepted - Whether terms are accepted
 */
function updateCheckoutButtonState(termsAccepted) {
  const submitButton = document.getElementById('checkout-submit')
  const cursorDiv = document.getElementById('cursor-div')
  
  if (!submitButton) return
  
  const tooltipMsg = 'Please Review the Terms and Conditions Before Proceeding'
  
  submitButton.disabled = !termsAccepted
  submitButton.classList.toggle('disabled', !termsAccepted)
  
  if (cursorDiv) {
    cursorDiv.classList.toggle('no-click-cursor', !termsAccepted)
  }
  
  // Handle tooltip
  const existingTooltip = bootstrap.Tooltip.getInstance(submitButton)
  
  if (termsAccepted) {
    if (existingTooltip) {
      existingTooltip.dispose()
    }
    submitButton.removeAttribute('title')
    submitButton.removeAttribute('data-bs-toggle')
  } else {
    submitButton.setAttribute('title', tooltipMsg)
    submitButton.setAttribute('data-bs-toggle', 'tooltip')
    if (!existingTooltip) {
      new bootstrap.Tooltip(submitButton)
    }
  }
}

/**
 * Sets up form validation for checkout submission
 * @param {HTMLFormElement} form - The checkout form element
 */
function setupFormValidation(form) {
  form.addEventListener('submit', (event) => {
    if (!areTermsAccepted()) {
      event.preventDefault()
      alert('Please accept the Terms and Conditions before placing your order.')
      return false
    }
    
    if (isCreditCardPaymentSelected() && !validateCreditCardFields()) {
      event.preventDefault()
      alert('Please fill in all credit card fields.')
      return false
    }
    
    return true
  })
}
